var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47422 19.6165C9.56839 19.6507 9.66422 19.6665 9.75922 19.6665C10.0309 19.6665 10.2942 19.5332 10.4517 19.2965L17.0259 9.46316C17.1967 9.20732 17.2134 8.87899 17.0684 8.60732C16.9234 8.33649 16.6409 8.16649 16.3334 8.16649H11.4284L12.0692 2.25649C12.1109 1.87566 11.8859 1.51482 11.5251 1.38399C11.1642 1.25232 10.7609 1.38399 10.5484 1.70399L3.97422 11.5365C3.80339 11.7923 3.78672 12.1215 3.93172 12.3932C4.07672 12.664 4.35922 12.8332 4.66672 12.8332H9.57172L8.93089 18.744C8.88922 19.1248 9.11422 19.4848 9.47422 19.6165ZM10.5001 11.1665H6.22589L10.0459 5.45315L9.67172 8.91065C9.64589 9.14565 9.72172 9.38065 9.88006 9.55649C10.0376 9.73232 10.2634 9.83315 10.5001 9.83315H14.7742L10.9542 15.5473L11.3284 12.089C11.3534 11.854 11.2776 11.619 11.1201 11.4432C10.9626 11.2673 10.7367 11.1665 10.5001 11.1665Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5413_96133",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 15,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47422 19.6165C9.56839 19.6507 9.66422 19.6665 9.75922 19.6665C10.0309 19.6665 10.2942 19.5332 10.4517 19.2965L17.0259 9.46316C17.1967 9.20732 17.2134 8.87899 17.0684 8.60732C16.9234 8.33649 16.6409 8.16649 16.3334 8.16649H11.4284L12.0692 2.25649C12.1109 1.87566 11.8859 1.51482 11.5251 1.38399C11.1642 1.25232 10.7609 1.38399 10.5484 1.70399L3.97422 11.5365C3.80339 11.7923 3.78672 12.1215 3.93172 12.3932C4.07672 12.664 4.35922 12.8332 4.66672 12.8332H9.57172L8.93089 18.744C8.88922 19.1248 9.11422 19.4848 9.47422 19.6165ZM10.5001 11.1665H6.22589L10.0459 5.45315L9.67172 8.91065C9.64589 9.14565 9.72172 9.38065 9.88006 9.55649C10.0376 9.73232 10.2634 9.83315 10.5001 9.83315H14.7742L10.9542 15.5473L11.3284 12.089C11.3534 11.854 11.2776 11.619 11.1201 11.4432C10.9626 11.2673 10.7367 11.1665 10.5001 11.1665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5413_96133)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.fd821261c993db7eaefee95b65b206f7.svg";
export { ForwardRef as ReactComponent };